import { UNRESTRICTED_ACTOR } from '../core/policy/actor';
import {
  type PurchaseOrderField,
  type PurchaseOrderStatus,
  purchaseOrderPolicy,
} from '../core/policy/entities/purchaseOrder';

export class Validator {
  public static active: PurchaseOrderStatus[] = ['SUBMITTED', 'RECEIVING', 'PENDING_LIQUIDATION'];

  public static isFieldEditable(
    field: PurchaseOrderField,
    status: PurchaseOrderStatus | undefined,
    isVendorAvailable = false
  ) {
    return purchaseOrderPolicy.decide(
      UNRESTRICTED_ACTOR,
      { status, hasVendor: isVendorAvailable },
      { type: 'edit', field }
    ).allowed;
  }
}
